import type { CardHooks } from "./registry";

/** Assisting Saber activates a choice for the player. 
 * They choose a weapon they own that is not disarmed, handled by the prompt. 
 * then the chosen weapon's block value is added to the pending buff for the next defend action.   
 */

export const assistingSaber: CardHooks = {
  onUtilityPlay: (ctx) => {
    const { self } = ctx;
    const eligibleSlots = self.equipSlots
      .map((slot, slotIdx) => ({ slot, slotIdx }))
      .filter(({ slot }) => slot.cardId && !slot.disarmed);
    if (!eligibleSlots.length) return {};
    return {
      prompt: {
        kind: "pick-weapon",
        playerNum: self.num,
        source: { cardId: "Assisting Sabor", instanceId: ctx.card.id },
        eligibleSlots: eligibleSlots.map(({ slot, slotIdx }) => ({
          slotIdx,
          cardId: slot.cardId as string,
          displayLabel: "weapon",
        })),
      },
      log: ["Assisting Saber — choose a weapon to add its block to your next defend!"],
    };
  },
};